import { render, staticRenderFns } from "./amendUp.vue?vue&type=template&id=7c8c0675&scoped=true&"
import script from "./amendUp.vue?vue&type=script&lang=js&"
export * from "./amendUp.vue?vue&type=script&lang=js&"
import style0 from "./amendUp.vue?vue&type=style&index=0&id=7c8c0675&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8c0675",
  null
  
)

export default component.exports